// src/config-client.js
const API_BASE = 'https://vc9kugsjnd.execute-api.eu-north-1.amazonaws.com/dev';

export async function fetchConfig({ venue, checkout }) {
  try {
    const checkoutParam = checkout ? `&checkout=${encodeURIComponent(checkout)}` : '';
    const res = await fetch(`${API_BASE}/widget/config?venue=${encodeURIComponent(venue)}${checkoutParam}`, {
      method: 'GET',
      credentials: 'omit',
    });
    if (!res.ok) return null; // 403 / 503 / 409 — all silent bail at loader level
    return await res.json();
  } catch {
    return null;
  }
}
